module.exports = __webpack_public_path__ + "img/serve2.5c9f308b.png";